import {
    SET_CURRENT_RESTAURANT,
} from '../types';

export const setCurrentRestaurant = (restId) => {
    return {
        type: SET_CURRENT_RESTAURANT,
        payload: restId
    };
};
